import React, { Component } from 'react';
import './Modal.css';

export const DefaultModalParams = {
  title: 'Info',
  content: 'Test Content Test Content Test Content Test Content Test Content',
  acceptText: 'OK',
  cancelText: 'CANCEL',
  isConfirm: false,
  onAccept: () => { /**/ },
  onCancel: () => { /**/ }
};

// Props
// title: string;
// content: string;
// acceptText: string;
// cancelText: string;
// isConfirm: boolean;
// onAccept?: () => void;
// onCancel?: () => void;

export default class Modal extends Component {

  closeModal = () => {
    this.props.handleClose();
  }

  cancelModal = () => {
    this.closeModal();
    this.props.onCancel && this.props.onCancel();
  }

  acceptModal = () => {
    this.closeModal();
    this.props.onAccept && this.props.onAccept();
  }

  getModalContent = () => {
    //multiple timeslots modal
    if (this.props.modalType === 1) {
      return (
        <div className={'Modal'}>
          <div className={'Modal-shield'} onClick={this.cancelModal}>{}</div>
          <div className={'Modal-content'}>
            <div className={'Modal-title'} id={'Modal-warn'}>
              {this.props.title}
            </div>
            <div className={'Modal-body'}>
              {this.props.content}
            </div>
            {!this.props.isConfirm && (
              <div className={'Modal-continue'} id={'Modal-warn-decline'} onClick={this.acceptModal}>
                {this.props.acceptText}
              </div>
            )}
            {this.props.isConfirm && (
              <div className={'Modal-acceptContainer'}>
                <div className={'Modal-cancel'} id={'Modal-warn-decline'}onClick={this.cancelModal}>
                  {this.props.cancelText}
                </div>
                <div className={'Modal-accept'} id={'Modal-warn-accept'} onClick={this.acceptModal}>
                  {this.props.acceptText}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className={'Modal'}>
          <div className={'Modal-shield'} onClick={this.cancelModal}>{}</div>
          <div className={'Modal-content'}>
            <div className={'Modal-title'}>
              {this.props.title}
            </div>
            <div className={'Modal-body'}>
              {this.props.content.split('\n').map(str => <p>{str}</p>)}
            </div>
            {!this.props.isConfirm && (
              <div className={'Modal-continue'} onClick={this.acceptModal}>
                {this.props.acceptText}
              </div>
            )}
            {this.props.isConfirm && (
              <div className={'Modal-acceptContainer'}>
                <div className={'Modal-cancel'} onClick={this.cancelModal}>
                  {this.props.cancelText}
                </div>
                <div className={'Modal-accept'} onClick={this.acceptModal}>
                  {this.props.acceptText}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }

  }

  render() {

    let modalContent = this.getModalContent();
    if (this.props.isOpen) {
      return modalContent;
    }
    else {
      return null;
    }
  }
}
